import { Component, Input } from '@angular/core';
import { DocumentData } from '../../../interfaces/section';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-policies-style',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './policies-style.component.html',
  styleUrl: './policies-style.component.scss'
})
export class PoliciesStyleComponent {
  @Input() documentData!: DocumentData
}
